import React, { Component } from 'react';
import FetchCall, { partnerApi, partnerCategory, partnerBranch, partnerAfaCategory, updateRemoveCategory } from  './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import ReactTooltip from "react-tooltip";

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class Category_tabv1 extends Component {
  constructor(props) {
    super(props);
    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let sid = urlParams.get('sid');
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      sid: sid != null ? sid : -1,
      category_data: [],
      subcategory_data: [],
      first_category_list: [],
      third_categorycollected: [],
      checking: false,
      btnDisable: false
    }
    this.validator = new SimpleReactValidator();
    this.getCategoryData();
    // this.getAFACategoryDataOnFirst();
  }

  handleRemovalCategory = (vendor_id, category_id, e) => {
    //console.log(vendor_id);

    if (window.confirm("You are sure?")) {

      window.jQuery('#row' + vendor_id).html("<strong>It is successfully removed</strong>");
      const { login_id, set_id } = this.state.user_data;
      let req_c = JSON.stringify({
        partner_id: login_id,
        category_id: category_id,
        sid: set_id,
        vendor_id: vendor_id,
        url: 'remove_category'
      });

      updateRemoveCategory(req_c).then(res => {
        if (res.status == 1) {
          window.location.href = '';
        } else {
          alert(res.message);
        }

      });
    }
  }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {
  }

  getAFACategoryDataOnFirst = async () => {
    const defaultCategories = [26, 27, 28, 29, 30, 31, 32];
    //const { user_type, login_id, set_id } = this.state.user_data;
    let req_c = JSON.stringify({
      categories: defaultCategories,
      url: 'partner_category_data_afa'
    });
    let THIS = this;
    await partnerAfaCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {

        this.setState({
          third_categorycollected: res_c.category_data
        })
      }
    })
  }

  getAFACategoryData = async (value, index) => {

    //const { user_type, login_id, set_id } = this.state.user_data;
    let req_c = JSON.stringify({
      categories: value,
      url: 'partner_category_data_afa'
    });
    let THIS = this;
    await partnerAfaCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {

        this.setState({
          third_categorycollected: res_c.category_data
        })
      }
    })
  }

  getCategoryData = async () => {
    const { user_type, login_id, set_id } = this.state.user_data;
    let sid = this.state.sid != -1 ? this.state.sid : set_id;
    let req_c = JSON.stringify({
      partner_id: login_id,
      sid: this.state.sid != -1 ? this.state.sid : set_id,
      user_type, user_type,
      role: 3,
      category_id: 0,
      url: 'partner_category_data'
    });
    let THIS = this;
    await partnerCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {

        this.setState({
          sid: sid,
          category_data: res_c.category_data,
          first_category_list: res_c.category_data[0].first_list
        })
      }
    })

    this.setState({
      checking: true
    })
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 5000)
  }
  checkHasSubCategory = async (current_arr, ele) => {
    let checkId = (ele == 'second_category') ? current_arr.first_category_id : current_arr.second_category_id;
    let THIS = this;
    const arr = (ele == 'second_category') ? current_arr.first_list : current_arr.second_category;
    console.log('checkId', arr)
    let temp = arr.filter((item) => item.is_parent == 1 && checkId.includes(item['category_id'].toString()));
    console.log('*** temp', temp)
    // if (temp.length === 1) {
    let item = temp.map(function (value) {
      return value.category_id;
    });
    console.log('checkId came inside', item)
    current_arr = await this.getCategory(item, ele, current_arr);
    current_arr['second_lbl'] = item['category_name'];
    // }
    this.setState({
      checking: true
    })
    setTimeout(function () {
      THIS.setState({
        checking: false
      })
    }, 500)
    return current_arr;
  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
  };

  loadSubCategories = async (e, i, name) => {

    alert(e.target.value);
    let req_c = JSON.stringify({
      categories: e.target.value,
      url: 'partner_category_data_afa'
    });
    let THIS = this;

    await partnerAfaCategory(req_c).then(async res_c => {
      if (res_c.status === 1) {

        this.setState({
          third_categorycollected: res_c.category_data
        })
      }
    })

  };

  handleCustomeSelect = async (e, i, name) => {

    const propName = e.target.name;
    var value = [...e.target.selectedOptions].map((item) => item.value);
    let category_data = this.state.category_data;
    category_data[i][propName] = value;
    if (propName == 'first_category_id') {
      category_data[i].second_category_id = [];
      category_data[i].second_category = [];
      category_data[i].third_category_id = [];
      category_data[i].third_category = [];
    } else if (propName == 'second_category_id') {
      category_data[i].third_category_id = [];
      category_data[i].third_category = [];
    }

    if (name == 'second_category' || name == 'third_category') {
      await this.checkHasSubCategory(category_data[i], name);
      await this.getAFACategoryData(value, i);
    }
    this.setState({ category_data });
  };

  getCategory = async (id, name, current_arr) => {
    id = id.length > 0 ? id : [444]
    console.log('getCategory', id, name, current_arr)
    let response = await FetchCall.getSubCategory(id);
    // console.log('getCategory', response)
    // return false;
    if (response.status === 1) {

      console.log('*** in', current_arr)
      current_arr[name] = response.results;

      if (name == 'second_category' || name == 'third_category') {
        let temp_name = name == 'second_category' ? 'third_category' : '';
        current_arr = await this.checkHasSubCategory(current_arr, temp_name);
        console.log('*** first', current_arr)
        let has_children = 0;
        let temp = [];
        if (name != 'fourth_category')
          temp = response.results.filter((item) => item.is_parent == 1);
        has_children = temp.length;
        console.log('temp', name)
        console.log('temp', temp_name)
        console.log('temp', temp)
        console.log('temp', has_children)
        let temp_selection = name == 'second_category' ? 'second_selection' : 'third_selection';
        current_arr[temp_selection] = true;
      }
    } else {
      current_arr[name] = [];
    }
    console.log('*** last', current_arr)
    return current_arr;
  }
  addCategory = (e) => {
    e.preventDefault;
    let temp = {
      first_category_id: [],
      first_list: this.state.first_category_list,
      second_category: [],
      second_category_id: [],
      second_selection: true,
      third_category: [],
      third_category_id: [],
      third_selection: true,
      uid: 0
    }
    let category_data = this.state.category_data;
    category_data.push(temp);
    this.setState({
      category_data
    });
  }
  render() {
    this.validator.purgeFields();
    const userdata = this.state.user_data;
    //console.log('this.state.category_data', this.state.category_data)
    console.log('this.state.subcategory_data', this.state.subcategory_data)
    const isValidNewOption = (inputValue, selectValue) =>
      inputValue.length > 0 && selectValue.length < 4;

    return (
      <React.Fragment>

        <div class="category_block">

        <div class="titleline">
          <h4>Category</h4>
        </div>
        
        <form onSubmit={this.submitForm} novalidate>

          <div class="box-shadow-custom">
            {this.state.sid != 0 && (
              <div className='row mar-btm pull-right'>
               { /*  <span  //removed based instruction )sethu, prachi Dec 5
                  className="notestext">To add category. Please contact Support&nbsp;<small><i class="fa fa-info-circle info-tool" data-tip data-for="addcategory-detail-tip" aria-hidden="true"></i></small>
            </span> */ }
                <div className='row mar-btm pull-right'>
                <span
                  className="btn btn-primary btn-sm" onClick={this.addCategory}>
                  <i class="fa fa-plus" aria-hidden="true"></i> Add Category
                </span>
                </div>
                <ReactTooltip id="addcategory-detail-tip" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                  <ul>
                    {this.state.first_category_list.map((item, i) => {
                      return (<li> {item.category_name}</li>)
                    })}
                  </ul>
                </ReactTooltip>
              </div>
            )}
           

            <br />

            <div className='row mar-top'>

              {this.state.category_data.length > 0 ?
                (
                  this.state.category_data.map((cat, i) => {
                    console.log('test', (this.state.sid))
                    return (
                      <div className={cat.is_active == 1 ? 'categoryrow activecatrow' : cat.is_active == 0 ? 'categoryrow payrestore' : 'categoryrow newcatrow'} id={"row" + cat.uid}>

                        <div className='row'>
                          <div class="col-md-6">
                            <label>Main Category</label>
                            <select className="form-control selectpicker"
                              title={"Select Category"}
                              name="first_category_id"
                              required
                              disabled={cat.uid != 0 ? true : false}
                              onChange={(e) => this.handleCustomeSelect(e, i, 'second_category')}
                              value={cat.first_category_id}>
                              {
                                cat.first_list.map((items, j) => {
                                  return (
                                    <option value={items.category_id} key={i + j + '1'}>{items.category_name}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label>Status</label>
                            <div className={cat.is_active == 1 ? 'statuslabel greenstatus' : cat.is_active == 0 ? 'statuslabel redstatus' : 'statuslabel newstatus'}>{cat.is_active == 1 ? 'Active' : cat.is_active == 0 ? 'Pay to restore' : 'New'}</div>
                            <div className={(i != 0 && this.state.sid != -1 && userdata.isSubpartner == false && cat.uid != 0) ? "btn blue-btn btn-sm" : "hidden"} onClick={(e) => this.handleRemovalCategory(cat.uid, cat.first_category_id, e)}>Remove</div>

                          </div>
                        </div>

                        <div className='row'>
                          <div class="col-md-6">
                            <label>Sub Category 1 <small><i class="fa fa-info-circle info-tool" data-tip data-for="subcateone-detail-tip" aria-hidden="true"></i></small></label>
                            <ReactTooltip id="subcateone-detail-tip" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                              <p>Sub Category 1 contains the classification of the main category. Its mandatory to chose this for every category!</p>
                            </ReactTooltip>
                            {cat.second_selection == true ? (
                              <select className="form-control selectpicker"
                                title={"Select Category"} required
                                name="second_category_id"
                                multiple
                                onChange={(e) => this.handleCustomeSelect(e, i, 'third_category')}
                                value={cat.second_category_id}>
                                {
                                  cat.second_category.map((itemstwo, k) => {

                                    if (itemstwo.category_id != 184) {
                                      return (
                                        <option value={itemstwo.category_id} key={i + k + '2'}>{itemstwo.category_name}</option>
                                      )
                                    }
                                  })
                                }
                              </select>

                            )
                              :
                              (
                                <select className="form-control selectpicker"
                                  title={"Select Category"}
                                  name="second_category_id"
                                  isValidNewOption={isValidNewOption}
                                  multiple required
                                  onChange={(e) => this.handleCustomeSelect(e, i, 'third_category')}
                                  value={cat.second_category_id}>
                                  {
                                    cat.second_category.map((itemstwo, k) => {
                                      return (
                                        <option value={itemstwo.category_id} key={i + k + '2'}>{itemstwo.category_name}</option>
                                      )
                                    })
                                  }
                                </select>

                              )}
                            <span className="greenstatus"> {cat.third_category.length > 0 ? 'Note: One of the sub categories has its own sub categories' : ''}</span>
                          </div>
                        </div>
                        <div className={cat.first_category_id == 4 ? 'row' : 'row'}>
                          <div class="col-md-6">
                            {cat.third_category.length > 0 && (
                              <div className="subcategories" id={"box" + i}>
                                <label>Sub Category 2  <small><i class="fa fa-info-circle info-tool" data-tip data-for="subcatetwo-detail-tip" aria-hidden="true"></i></small></label>
                                <ReactTooltip id="subcatetwo-detail-tip" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                                  <p>Sub Category 2 contains the sub divisions for each of Sub Category 1. Its mandatory to chose this for Afterschools category.</p>
                                </ReactTooltip>
                                <select className="form-control selectpicker 1"
                                  title={cat.third_lbl ? cat.third_lbl : "Select Category"}
                                  name="third_category_id"
                                  multiple
                                  //onloadCallback={(e)=>this.loadSubCategories(e)}
                                  onChange={(e) => this.handleCustomeSelect(e, i, 'fourth_category')}
                                  value={cat.third_category_id}>
                                  {
                                    cat.third_category.map((itemsthree, l) => {
                                      return (
                                        <option value={itemsthree.category_id} key={i + l + '3'}>{itemsthree.category_name} ({itemsthree.parent})</option>
                                      )
                                    })
                                  }
                                </select>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  })

                ) :
                (
                  <tr>
                    <td colSpan='3'></td>
                  </tr>
                )
              }

            </div>

          </div>
          <div className='box-shadow-custom'>
            <h5 className='astrick'><b>Notes</b></h5>
            <ul>
            <li>Each category/vertical selection will be add as a new subscription at (50% base price)</li>
            <li>Please suffix location to the name of the institution when you add a branch or category</li>
            <li>If you need help - please write to us at contact@bewise.in</li>
            { /* 
              <li>Every category selection will be  a new subscription</li>
              {this.state.sid != 0 && (<li>To add a new category please click, add category on top right</li>)}
              <li>Once categories are added and saved, cannot be changed further</li>
              <li>Every time there is an updation in any category, the Overview and Contact person details should be saved/published</li>
              <li>Status column denotes the status of every category subscription</li>
            */ }
            </ul>
          </div>
          <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
            <button type='submit' id="btnSubmit"
              className="btn btn-primary btn-sm" disabled={this.state.btnDisable}>
              {this.state.btnDisable ? 'Please Wait...' : 'Save'}
            </button>
          </div>
          
        </form >

        </div>
        <NotificationContainer/>      
      </React.Fragment >

    );
  }
  submitForm = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        btnDisable: true
      })
      const { user_type, login_id, set_id } = this.state.user_data;
      let req_c = JSON.stringify({
        partner_id: login_id,
        sid: this.state.sid != -1 ? this.state.sid : set_id,
        user_type, user_type,
        role: 3,
        category_data: this.state.sid == 0 ? this.state.category_data[0] : this.state.category_data,
        url: 'save_category'
      });
      if (this.state.sid == 0) {
        partnerBranch(req_c).then(res => {
          //let toastr = '';
          this.setState({
            btnDisable: false
          })
          if (res.status === 1) {
            NotificationManager.success(res.message);
            //toastr = window.toastr.success;
            setTimeout(function () {
              window.location.href = `/partner/profile?sid=${res.set_id}`;
            }, 1000);
          } else {
            NotificationManager.error(res.message);
            //toastr = window.toastr.error;
          }

          /*
          toastr(res.message, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          */

        });
      } else {
        partnerCategory(req_c).then(res => {
          //let toastr = '';
          this.setState({
            btnDisable: false
          })
          if (res.status === 1) {
            //toastr = window.toastr.success;
            NotificationManager.success(res.message);
            setTimeout(function () {
              window.location.reload();
            }, 1000);

          } else {
            NotificationManager.error(res.message);
            //toastr = window.toastr.error;
          }

          /*
          toastr(res.message, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          */


        });
      }

    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
}

export default Category_tabv1;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/update_profile/categoryv1.jsx